import React, { useContext, useEffect } from "react";
import Card from "../Card";
import { WalletItems } from "../../App";
import WalletItemsCard from "../WalletItemsCard";

const CardWrapper = ({ formik, walletItem, setWalletItem }) => {
    const walletItems = useContext(WalletItems);

    useEffect(() => {
        const isFrameReady = window.Frames?.currentConfig?.publicKey;

        if(!walletItem && isFrameReady) {
            window.Frames.init();
        }
    }, [walletItem]);
    return (
        <>
            {
                walletItems && walletItems.length ?
                    <WalletItemsCard
                        walletItem={walletItem}
                        setWalletItem={setWalletItem}
                    /> : <></>
            }
            {
                !walletItems || !walletItems.length || !walletItem
                    ? <Card formik={formik} />
                    : <></>
            }
        </>
    )
}

export default CardWrapper;
